import { render } from "./NavigationTitle.vue?vue&type=template&id=cb4880a0&scoped=true"
import script from "./NavigationTitle.vue?vue&type=script&lang=js"
export * from "./NavigationTitle.vue?vue&type=script&lang=js"

import "./NavigationTitle.vue?vue&type=style&index=0&id=cb4880a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4880a0"]])

export default __exports__